
import {
  BillingSessionPostResponse,
  BillingSessionPostUpdateResponse,
  PlanTier,
} from '@flagsync/skyline';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { sky } from '@/services/api-client';
import { ServiceError } from '@/services/utils/service-error';

export interface GetBillingSessionVariables {
  organizationId: number;
}

export interface GetBillingSessionForUpdateVariables {
  organizationId: number;
  planTier: PlanTier;
  quantity: number;
}

export function useGetBillingSession(
  options?: UseMutationOptions<string, ServiceError, GetBillingSessionVariables>,
) {
  return useMutation<string, ServiceError, GetBillingSessionVariables>({
    mutationFn: async (variables) => {
      const response = await sky.post<BillingSessionPostResponse>(
        `/stripe/billing/${variables.organizationId}`,
        {},
      );
      if (!response?.url) {
        throw new ServiceError({
          message: 'No billing session URL returned',
        });
      }
      return response.url;
    },
    ...options,
  });
}

export function useGetBillingSessionForUpdate(
  options?: UseMutationOptions<
    string,
    ServiceError,
    GetBillingSessionForUpdateVariables
  >,
) {
  return useMutation<string, ServiceError, GetBillingSessionForUpdateVariables>(
    {
      mutationFn: async (variables) => {
        const response = await sky.post<BillingSessionPostUpdateResponse>(
          `/stripe/billing/${variables.organizationId}/update`,
          {
            planTier: variables.planTier,
            quantity: variables.quantity,
          },
        );
        if (!response?.url) {
          throw new ServiceError({
            message: 'No billing session URL returned',
          });
        }
        return response.url;
      },
      ...options,
    },
  );
}
